import { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";

import { getApi } from "../../../../api/api";
import { ComplexOrderInterface } from "../../../../common/types/interfaces";

export const useComplexOrderDetails = () => {
  const { id } = useParams<{ id: string }>();

  const [order, setOrder] = useState<ComplexOrderInterface | null>(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!id) return;
    setLoading(true);
    try {
      const res = await getApi().getComplexOrder(Number(id));
      setOrder(res);
    } catch {
      setOrder(null);
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    load();
  }, [load]);

  return { order, ready: !loading };
};
